import { setUpAPI } from "../../Utils/api.utils";

export const asset_getMyActiveListings = async (userID, pageIndex, pageCount, userTokenId) => {
  const data = {
    cmd: "iAsset_GetMyActiveListings_stg",
    userId: userID,
    userTokenId: userTokenId,
    pageIndex: pageIndex,
    pageCount: pageCount,
  };

  const response = await setUpAPI("IssuerAsset", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const asset_getByEntryId = async (entryid, step = 1) => {
  const data = {
    cmd: "iAsset_GetByentryid",
    processStep: step,
    entryid: entryid,
  };

  const response = await setUpAPI("IssuerAsset", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};
export const LegalRightTransfer_FileURL = async (entryid, id ,LegalRightTransferFileURL) => {
  const data = {
    cmd: "maRightTranserAgreement_UpdateFileURL",
    id: id,
    entryid: entryid,
    LegalRightTransferFileURL:LegalRightTransferFileURL
  };

  const response = await setUpAPI("IssuerAssetRightTransferAgreement", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const asset_AddUpdate = async (userID, listing) => {
  const data = {
    cmd: "iAsset_AddUpdate",
    userId: userID,
    ...listing,
  };

  const response = await setUpAPI("IssuerAsset", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};


export const iAsset_SaveEntryInvestorInformation = async (userID, listing) => {
  const data = {
    cmd: "iAsset_SaveEntryInvestorInformation",
    userId: userID,
    ...listing,
  };

  const response = await setUpAPI("IssuerAsset", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};
export const asset_submitForReview = async (values) => {
  const data = {
    cmd: "iAsset_SubmitListing",
    Discontcode: values.Discountcode,
    ccType: values.ccType,
    ccNumber: values.ccNumber,
    ccCardHolder: values.ccCardHolder,
    ccExpDate: values.ccExpDate,
    entryid: values.entryid,
    processStep: values.assetProcess.processStep,
    agreedToTransfer: values.assetProcess.agreedToTransfer,
    signature: values.assetProcess.signature,
  };

  const response = await setUpAPI("IssuerAsset", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const asset_saveListing = async (values) => {
  const data = {
    cmd: "iAsset_SaveOnly",
    entryid: values.entryid,
    processStep: values.assetProcess.processStep,
    agreedToTransfer: values.assetProcess.agreedToTransfer,
    signature: values.assetProcess.signature,
  };

  const response = await setUpAPI("IssuerAsset", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const asset_cancelListing = async (values) => {
  const data = {
    cmd: "iAsset_CancelListing",
    entryid: values.entryid
  }

  const response = await setUpAPI("IssuerAsset", data, "POST", null).catch(
    (error) => {
      return error;
    }
  )

  return response;
}

export const asset_SaveRightsTransfer = async (values) => {
  console.log('values', values);
  const data = {
    cmd: 'iAsset_SaveRightsTransfer',
    entryid:values.entryid,
  }
  const response = await setUpAPI("IssuerAsset", data, "POST", null).catch(
    (error) => {
      return error
    }
  );

  return response.json();


}